import { postLogin } from '@_api/login';

const signIn = {
  init: function () {
    this.addEvent();
    window.redirectAfterLogin = false;
    window.selectedSku = '';
  },
  addEvent: function () {
    let forms = document.querySelectorAll<HTMLElement>('.saig-o-sign-in__form');
    const passwordIcon = document.querySelector<HTMLSpanElement>('.saig-o-sign-in__password-icon');

    passwordIcon?.addEventListener('click', this.togglePasswordIcon.bind(this));
    for (const form of forms) {
      form.addEventListener('submit', this.submitHandler.bind(this));
    }
  },
  togglePasswordIcon: function (event: any) {
    const passwordEyeIcon = document.querySelector<HTMLSpanElement>('.saig-o-sign-in__password-eye-icon');
    const passwordEyeOffIcon = document.querySelector<HTMLSpanElement>('.saig-o-sign-in__password-eye-off-icon');
    let passwordInput = document?.querySelector<HTMLInputElement>('.saig-o-sign-in__password');

    if (passwordEyeIcon?.classList.contains('show')) {
      passwordEyeIcon?.classList.remove('show');
      passwordEyeOffIcon?.classList.add('show');
      if (passwordInput != undefined) {
        passwordInput.type = 'text';
      }
    } else {
      passwordEyeOffIcon?.classList.remove('show');
      passwordEyeIcon?.classList.add('show');
      if (passwordInput != undefined) {
        passwordInput.type = 'password';
      }
    }
  },
  submitHandler: function (event: SubmitEvent) {
    event.preventDefault();
    let form = event.target as HTMLFormElement;
    let emailInput = form?.querySelector<HTMLInputElement>('.saig-o-sign-in__email');
    let passwordInput = form?.querySelector<HTMLInputElement>('.saig-o-sign-in__password');
    let dataAttrAPI = document?.querySelector<HTMLDivElement>('.saig-o-sign-in__inner');
    this.hideError(form);
    if (this.validateInputs(form, emailInput?.value?.trim(), passwordInput?.value?.trim())) {
      postLogin(emailInput?.value?.trim(), passwordInput?.value?.trim(), dataAttrAPI?.dataset.apiUrl ?? '')
        .then((response) => {
          if (response == 'Success') {
            const redirectRequired = window.redirectAfterLogin;
            const selectedSku = window.selectedSku;
            const redirectURLAfterLogin = window.redirectURLAfterLogin;
            window.redirectAfterLogin = false;
            window.redirectURLAfterLogin = '';
            window.selectedSku = '';
            if (redirectRequired) {
              if (redirectURLAfterLogin && redirectURLAfterLogin.length > 0) {
                window.location.href = redirectURLAfterLogin;
              } else {
                dataAttrAPI && dataAttrAPI.dataset.redirectUrl && (window.location.href = dataAttrAPI?.dataset?.redirectUrl);
              }
            }
            else {
              selectedSku && selectedSku.length > 0
                ? (window.location.href = window.location.pathname + '?selected=' + selectedSku)
                : window.location.reload();

            }
          } else if (response == 'APIError') {
            this.showError(form, 'server-side-error', undefined, dataAttrAPI?.dataset.apiErrorMessage ?? '');
          } else {
            this.showError(form, 'server-side-error', undefined, ' Invalid Email/Password. Please try again!');
          }
        })
        .catch((error) => {
          this.showError(form, 'server-side-error', undefined, dataAttrAPI?.dataset.genericErrorMessage ?? '');
        });
    }
  },
  validateInputs: function (form?: HTMLFormElement, emailInput?: string, passwordInput?: string) {
    let valid = true;
    if (!this.validateEmail(emailInput?.trim())) {
      this.showError(form, 'email-required-validation', 'email');
      valid = false;
    }
    if (!passwordInput?.trim()) {
      this.showError(form, 'password-required-validation', 'password');
      valid = false;
    }
    return valid;
  },
  validateEmail: function (email?: string) {
    return email
      ? email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      : false;
  },
  showError: function (form?: HTMLFormElement, className?: string, inputElement?: string, errorMsg?: string) {
    if (!form) return;

    if (inputElement) {
      form?.querySelector<HTMLDivElement>('.saig-o-sign-in__' + inputElement)?.classList?.add('error-border');
    }
    if (className) {
      form?.querySelector<HTMLDivElement>('.saig-o-sign-in__form-error' + '.' + className)?.classList?.add('show');
    }
    if (errorMsg) {
      const genericErrorDiv = form.querySelector<HTMLDivElement>(
        '.saig-o-sign-in__form-error' + '.' + className + ' .saig-o-sign-in__form-error-message'
      );
      genericErrorDiv && (genericErrorDiv.innerHTML = errorMsg);
    }
  },
  hideError: function (form: HTMLFormElement) {
    if (!form) return;
    const errorElements = form?.querySelectorAll<HTMLDivElement>('.saig-o-sign-in__form-error');
    [].forEach.call(errorElements, (errorDiv: HTMLElement) => {
      errorDiv.classList.remove('show');
    });
    form?.querySelector<HTMLInputElement>('.saig-o-sign-in__email')?.classList.remove('error-border');
    form?.querySelector<HTMLInputElement>('.saig-o-sign-in__password')?.classList.remove('error-border');
  },
};

signIn.init();

export { signIn };
